import React from 'react';
// Components
import ManageExperienceTable from 'components/common/ManageExperienceTable';

const ManageOrganizationProducts: React.FC = () => {
  return <ManageExperienceTable />;
};

export default ManageOrganizationProducts;
